import React, { useEffect, useState } from 'react';
import './terms.scss';
import axios from 'axios';
import { Container } from '@mui/material';

const Terms = () => {
    const [terms, setTerms] = useState('');
    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get('/api/terms-and-conditions')
            .then((res) => {
                console.log(res.data);
                setTerms(res.data.content);
            });
    }, []);

    return <Container
        maxWidth="md"
        className="terms"
    >
        <div className="container">
            <div className="terms-content-container" dangerouslySetInnerHTML={{ __html: terms }}></div>
        </div>
    </Container>;
};

export default Terms;
